import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Kansas City",
  shortName: "Blue KC",
  slug: "blue-kc-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Kansas City TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Kansas City policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Blue KC TMS coverage, Blue Cross Blue Shield Kansas City SPRAVATO authorization, Blue KC mental health benefits Coral Springs FL, Blue KC depression treatment Florida",
};

export const BlueKcInsurance = () => <InsurancePageTemplate config={config} />;
export default BlueKcInsurance;
